import React, { useState } from "react";

import ProgressBar from "../common/ProgressBar";
import t from "../../../../Common/utils/translation/translator";

// MSC-1778: Component ComparatorLine must be commonalized
import ComparatorLine from "../../../../Retrofit/components/Devices/BundleComparator/ComparatorLine";

const AxisComparatorMechanicalComparatorSelection = ({ compareDatas, ...props }) => {
  const [showMechanical, setMechanical] = useState(true);
  return (
    <div className="AxisComparatorMechanicalComparatorSelection" {...props}>
      <ComparatorLine
        compareData={compareDatas}
        title={t("cartesian.ui.axis_selection.mechanical_values")}
        isSectionHeader
        opened={showMechanical}
        values={compareDatas.map(() => "")}
        onClick={() => setMechanical(!showMechanical)}
      />
      {showMechanical && (
        <>
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.stroke")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.strokeUtilization}
                data-testid="progress-bar-strokeUtilization"
              />
            ))}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.speed")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.speedAxisUtilization}
                data-testid="progress-bar-speedAxisUtilization"
              />
            ))}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.acceleration")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.speedAxisUtilization}
                data-testid="progress-bar-acceleration"
              />
            ))}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.force_fx")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.forceFxUtilization}
                data-testid="progress-bar-forceFxUtilization"
              />
            ))}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.drive_torque")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.driveTorqueUtilization}
                data-testid="progress-bar-driveTorqueUtilization"
              />
            ))}
          />
        </>
      )}
    </div>
  );
};

export default AxisComparatorMechanicalComparatorSelection;
